import React, { useEffect, useState } from 'react';
import {
  isNotificationShownToday,
  setCookie,
} from 'components/CookieNotification/constants';
import { getText } from 'services/languageService';
import './style.css';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Switch,
} from '@mui/material';

export const CookieNotification: React.FC = () => {
  const [showNotification, setShowNotification] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(true);
  };

  function showCookieNotification() {
    setShowNotification(true);
  }

  const hideNotification = () => {
    const cookieName = 'cookieNotificationShown';
    setShowNotification(false);
    setCookie(cookieName, new Date().toISOString(), 1); // Устанавливаем куку на 1 день
  };

  useEffect(() => {
    if (!isNotificationShownToday()) {
      showCookieNotification();
    }
  }, []);

  return showNotification ? (
    <>
      <div className="cookie-overlay"></div>
      <div className="cookie-notice" id="cookieNotice">
        <p id="cookie-text">{getText('COOKIE_NOTIFICATION_TEXT')}</p>
        <Button
          onClick={() => setOpen(true)}
          variant="outlined"
          style={{ marginRight: '0.5rem' }}
        >
          {getText('COOKIE_NOTIFICATION_BTN_CHANGE')}
        </Button>
        <Button onClick={hideNotification} variant="contained">
          {getText('COOKIE_NOTIFICATION_BTN')}
        </Button>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {getText('COOKIE_NOTIFICATION_EXTEND_TITLE')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <FormGroup>
                <FormControlLabel
                  control={<Switch defaultChecked />}
                  label={getText('COOKIE_EXTEND_NECESSARY')}
                  disabled
                />
                <FormControlLabel
                  control={<Switch />}
                  label={getText('COOKIE_EXTEND_ANALITYCS')}
                />
              </FormGroup>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>
              {' '}
              {getText('COOKIE_NOTIFICATION_BTN_REJECT')}
            </Button>
            <Button variant="contained" onClick={hideNotification} autoFocus>
              {getText('COOKIE_NOTIFICATION_BTN')}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  ) : null;
};
